import React, { useState, useEffect } from "react";
import { useAuthProvider } from "pages/Auth/hooks/useAuthProvider";
import {
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Result } from "antd";
import whitelabelConfig from "@whitelabel-config";
import { persistor } from "store/index";
import { clearLocalStore } from "helpers/localStoreSrv";
const LandingMemberPortal = (props: { target?: string; auth?: string }) => {
  const navigate = useNavigate();
  const { initAuth, isSessionAuthenticated, updateAuthSession } =
    useAuthProvider();
  const [targetComponent, setTargetComponent]: any = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const prepareSessionDatas = async () => {
    setTargetComponent((prvState: any) => {
      return props.target
        ? props.target
        : whitelabelConfig.uiSettings.landingModule;
    });
  };

  const navToTarget = async (target: string) => {
    let loginId = searchParams.get("id");
    console.log(target, loginId, props);
    if (loginId) {
      const authSession = {
        auth_progress: "NOT-STARTED",
        user_id: loginId,
      };
      updateAuthSession(authSession);
    }
    if (isSessionAuthenticated()) {
      navigate(target);
    } else {
      initAuth(props.auth);
    }
  };
  useEffect(() => {
    (async () => {
      await persistor.purge();
      await persistor.flush();
      clearLocalStore();
      prepareSessionDatas();
    })();
  }, []);

  useEffect(() => {
    if (targetComponent) {
      navToTarget(targetComponent);
    }
  }, [targetComponent]);

  return (
    <Result
      data-testid="landing-microsite-container"
      status="success"
      title="Welcome to HealConnect Member Portals"
      subTitle="This is your Microsite landing."
    />
  );
};
export default LandingMemberPortal;
